<template>
    <b-form @submit.prevent="tryToSendOTP">
        <b-form-group label="Phone" label-for="phone">
            <b-form-input
                id="phone"
                ref="phoneInput"
                v-model="phone"
                type="text"
                placeholder="Enter phone"
                :class="{
                    'is-invalid': hasError('phone')
                }"
            />
            <div class="invalid-feedback">
                {{ getError('phone') }}
            </div>
        </b-form-group>

        <b-alert
            v-if="phoneError"
            show
            dismissible
            variant="danger"
            class="text-center"
        >
            {{ phoneError }}
        </b-alert>

        <b-form-group class="mt-4">
            <b-button
                type="submit"
                variant="primary"
                class="btn-block"
                :disabled="inProgress"
            >
                Send OTP
            </b-button>
        </b-form-group>
    </b-form>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { StatusCodes as HTTP } from 'http-status-codes';
import validatePhoneFormat from '@/helpers/validatePhoneFormat';

export default {
    validations: {
        phone: {
            required,
            isFormatValid: v => validatePhoneFormat(v)
        }
    },

    data() {
        return {
            phone: '',
            phoneError: '',
            inProgress: false,
            serverErrors: []
        };
    },

    mounted() {
        this.$refs.phoneInput.focus();
    },

    methods: {
        ...mapActions({
            sendOTP: 'auth/sendOTP'
        }),

        async tryToSendOTP() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            this.phoneError = '';
            this.inProgress = true;

            try {
                await this.$recaptchaLoaded();
                const token = await this.$recaptcha('otp');

                await this.sendOTP({ phone: this.phone, token });

                this.$emit('otp-sent', this.phone);
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (data && data.error) {
                        this.phoneError = data.error;

                        return;
                    }

                    if ([401, 403, 404].includes(status)) {
                        this.phoneError =
                            "User with following phone number doesn't exist.";

                        return;
                    }

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            } finally {
                this.inProgress = false;
            }
        },

        hasError(key) {
            return (
                this.$v[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.$v,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
